<template>
  <div class="flexCenterCenter">
    <section class="card-band-styling">
      <div>
        <h3>New Application</h3>
<!--         <div style="text-align: right;">
          <label for="import-csv-example" class="input-file-label mr-2" @click="downloadExampleCSV()">Example CSV
            <font-awesome-icon :icon="['fas', 'file-arrow-down']" style="margin-left: 10px;" />
            <a style="display: none;" id="import-csv-example" href="/static/Import_AppAdmin_Example.csv" download></a>
          </label>
          <label for="imported-csv" class="input-file-label">Import from CSV
            <font-awesome-icon :icon="['fas', 'file-arrow-up']" style="margin-left: 10px;" />
            <input id="imported-csv" @change="csvChange()" accept=".csv" type="file">
          </label>
        </div> -->
        <div style="text-align: right;">{{ csvName }}</div>
      </div>
      <form id="createNewForm" @submit.prevent="submit">
        <table style="border-spacing: 5px;">
          <tr>
            <td>
              <label>Classification*:</label>
            </td>
            <td style="width: 80%;">
              <select name="classification" v-model="inputObject.classification">
                <option value="Assessment/Test">Assessment/Test</option>
                <option value="Screening/Mini-Test">Screening/Mini-Test</option>
                <option value="Intervention/Training/Lesson">Intervention/Trainging/Lesson</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>
              <label>Title*:</label>
            </td>
            <td>
              <input name="title" type="text" v-model="inputObject.title" required>
            </td>
          </tr>
          <tr>
            <td>
              <label>Subtitle:</label>
            </td>
            <td>
              <input name="subtitle" type="text" v-model="inputObject.subtitle">
            </td>
          </tr>
          <tr>
            <td>
              <label>Custom Id*:</label>
            </td>
            <td>
              <input name="application_custom_id" type="text" v-model="inputObject.customID" required>
            </td>
          </tr>
          <tr>
            <td>
              <label>Info:</label >
            </td>
            <td>
              <input name="info" type="text" v-model="inputObject.info">
            </td>
          </tr>
          <tr>
            <td>
              <label>Area*:</label>
            </td>
            <td>
              <input name="area" type="text" v-model="inputObject.area" required>
            </td>
          </tr>
          <tr>
            <td>
              <label>Image/Logo:</label>
            </td>
            <td>
              <label class="custom-file-label-global">Upload
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z"/></svg>
                <input name="image" id="imported-logo" @change="logoChange()" type="file" accept=".jpg, .jpeg, .png, .gif, .svg">
              </label>
              <div class="flexCenterCenter">
                <img id="preview-image">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>For Sale:</label>
            </td>
            <td>
              <select name="on_sale" v-model="inputObject.onSale">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="button-container">
          <button v-if="!loadingCreateNewApp" type="submit">Create Application</button>
          <button v-else>
            <b-spinner small></b-spinner>
            Create Application
          </button>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
  import instance from '../axios.js';
  import { v4 as uuidv4 } from 'uuid';
  //import Papa from 'papaparse';

  export default {
    data() {
      return {
        csvName: null,
        loadingCreateNewApp: false,
        inputObject: {
          classification: 'Assessment/Test',
          title: '',
          subtitle: '',
          customID: '',
          info: '',
          area: '',
          logo: '',
          onSale: 'No',
          isFree: false,
          pricingUnit: 'USD',
          pricingNumber: '',
          largeQuantityPricingAmount: '',
          largeQuantityPricingDiscount: '',
          monthlySubscription: '',
        }
      }
    },
    methods: {
      downloadExampleCSV() {
        let reference = document.getElementById('import-csv-example');
        reference.click();
      },
      csvChange() {
        let csvRef = document.getElementById('imported-csv');
        if (csvRef.files.length > 0) {
          let file = csvRef.files[0];
          this.csvName = file.name;
        }
      },
      async logoChange() {
        const inputElement = document.getElementById("imported-logo");
        const previewImage = document.getElementById("preview-image");
        if (inputElement.files.length > 0) {
          const selectedFile = inputElement.files[0];
          this.inputObject.logo = selectedFile;
          previewImage.src = URL.createObjectURL(selectedFile);
          previewImage.style.display = "block";
          this.inputObject.logo = selectedFile;
        } 
        else {
          previewImage.src = "";
          previewImage.style.display = "none";
          this.inputObject.logo = '';
        }
      },
      submit() {
        this.loadingCreateNewApp = true;
/*         let csvRef = document.getElementById('imported-csv');
        if (csvRef.files.length > 0) {
          Papa.parse(csvRef.files[0], {
            transform: (value) => {
              if (value === "TRUE") return true;
              if (value === "FALSE") return false;
              return value;
            },
            complete: (result) => {
              // Remove empty rows
              const filteredData = result.data.filter(row => Object.values(row).some(value => value !== ''));
              const headers = filteredData[0];

              let allQuestions = [];
              let activity_id = uuidv4();
              for (let i = 1; i < filteredData.length; i++) {
                const rowData = filteredData[i];
            
                const obj = {};
                for (let j = 0; j < headers.length; j++) {
                  obj[headers[j]] = rowData[j];
                }
                allQuestions.push({
                  ...obj,
                  application_id: activity_id,
                  question_order: parseInt(obj.question_order, 10),
                  area_order: parseInt(obj.area_order, 10),
                  type_order: parseInt(obj.type_order, 10),
                  category_order: parseInt(obj.category_order, 10),
                  sub_category_order: parseInt(obj.sub_category_order, 10),
                  TTS_child_prompts: JSON.parse(obj.TTS_child_prompts),
                  question_id: uuidv4(),
                  transparent: obj.transparent.toUpperCase() == "TRUE" ? true : false
                });
              }
              const formData = new FormData();
              formData.append("application_id", activity_id);
              formData.append("application_custom_id", this.inputObject.customID);
              formData.append("owner_uuid", `${this.$store.getters.getCurrentUser}`);
              formData.append("classification", this.inputObject.classification);
              formData.append("title", this.inputObject.title);
              formData.append("subtitle", this.inputObject.subtitle);
              formData.append("info", this.inputObject.info);
              formData.append("image", this.inputObject.logo); 
              formData.append("on_sale", this.inputObject.onSale);
              formData.append("single_unit_pricing", `${this.inputObject.pricingNumber} ${this.inputObject.pricingUnit}`);
              formData.append("large_quantity_discount", `${this.inputObject.largeQuantityPricingAmount} Units for ${this.inputObject.largeQuantityPricingDiscount}% Discount`);
              formData.append("monthly_subscription_pricing", `${this.inputObject.largeQuantityPricingAmount} ${this.inputObject.monthlySubscription}`);
              formData.append("published", false);

              instance.post('/api/appAdmin', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(res => {
                console.log(res.data);
                instance.post('/api/question-admin/questions', allQuestions)
                .then(res => {
                  console.log(res.data);
                  this.$router.push(`/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/${activity_id}`);
                })
                .catch(err => {
                  console.error(err);
                });
              })
              .catch(err => {
                console.error(err);
              });
            },
            error: (error) => {
              console.error('CSV parsing error:', error.message);
            },
          });
        }
        else {
          let activity_id = uuidv4();
          const formData = new FormData();
          formData.append("application_id", activity_id);
          formData.append("application_custom_id", this.inputObject.customID);
          formData.append("owner_uuid", `${this.$store.getters.getCurrentUser}`);
          formData.append("classification", this.inputObject.classification);
          formData.append("title", this.inputObject.title);
          formData.append("subtitle", this.inputObject.subtitle);
          formData.append("info", this.inputObject.info);
          formData.append("image", this.inputObject.logo); 
          formData.append("on_sale", this.inputObject.onSale);
          formData.append("single_unit_pricing", `${this.inputObject.pricingNumber} ${this.inputObject.pricingUnit}`);
          formData.append("large_quantity_discount", `${this.inputObject.largeQuantityPricingAmount} Units for ${this.inputObject.largeQuantityPricingDiscount}% Discount`);
          formData.append("monthly_subscription_pricing", `${this.inputObject.largeQuantityPricingAmount} ${this.inputObject.monthlySubscription}`);
          formData.append("published", false);
          instance.post('/api/appAdmin', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            console.log(res.data);
            this.$router.push(`/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/${activity_id}`);
          })
          .catch(err => {
            console.error(err);
          });
        } */
        let activity_id = uuidv4();
        const formData = new FormData(document.getElementById('createNewForm'));
        formData.append("application_id", activity_id);
        formData.append("owner_uuid", `${this.$store.getters.getCurrentUser}`);
        formData.set("on_sale", formData.get("on_sale") == 'true' ? true : false);
        formData.append("is_free", this.inputObject.isFree); 
        formData.append("currency_code", this.inputObject.pricingUnit); 
        formData.append("single_unit_pricing", this.inputObject.pricingNumber);
        formData.append("large_quantity_discount", this.inputObject.largeQuantityPricingDiscount);
        formData.append("monthly_subscription_pricing", this.inputObject.monthlySubscription);
        formData.append("published", false);

        this.loadingCreateNewApp = false;
        instance.post('/api/appAdmin', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(res => {
          console.log(res.data);
          this.loadingCreateNewApp = false;
          this.$router.push(`/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/${activity_id}`);
        })
        .catch(err => {
          console.error(err);
          this.loadingCreateNewApp = false;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';
  
  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flexCenterCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flexBtwCenter {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  section {
    border-radius: 2rem;
    width: 50vw;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: 'Roboto', sans-serif;

    h3 {
      text-align: center;
      font-weight: 700;
    }
  }

  table {
    td {
      padding: 5px;
      font-size: 1rem;
      font-weight: 700;
    }

    input {
      background-color: white;
      border-radius: 50rem;
      padding-left: .5rem;
      padding-right: .5rem;
      width: 100%;
      font-size: 1rem;
      font-weight: 400;
    }

    tr td:first-child {
      font-weight: 700;
      display: flex;
      align-items: center;
    }

    label {
      display: inline-block;
      margin-bottom: 0;
    }

    .table-section-divider {
      text-align: center;
      border-top: dashed black 1px;
      border-top-width: 2px;
    }
  }

  .input-file-label {
    width: fit-content;
    font-weight: 400;
    cursor: pointer;

    border-radius: 50rem;
    border: solid 1px globalSharedVariables.$orange-1;
    box-shadow: 0 0 5px 0 grey;
    padding: 0 10px;
    font-size: 1rem;
    outline: none; 

    &:hover {
      background-color: globalSharedVariables.$orange-1;
    }
  }

  .input-file-label input[type="file"] {
    display: none;
  }

  #preview-image {
    display: none;
    margin-top: .5rem;
    margin-bottom: .5rem;
    width: 100%;
  }

</style>